import React, { useState } from "react";

const Layanan = () => {
  const [activeTab, setActiveTab] = useState("edukasi");
  return (
    <>
      <div className="font-inter">
        {/* Header / Hero Section */}
        <section className="relative h-[600px] sm:h-[700px] md:h-[800px] overflow-hidden font-inter">
          {/* Gradient Merah ke Putih */}
          <div className="absolute inset-0 bg-gradient-to-r from-[#D32F2F] to-white z-0" />

          {/* Gambar Lebih Besar */}
          <img
            src="/images/asset/orang-layanan.png"
            alt="Latar Layanan"
            className="absolute bottom-0 right-0 w-full sm:w-auto sm:max-w-[90%] md:max-w-[85%] lg:max-w-[80%] xl:max-w-[75%] object-contain z-10"
          />

          {/* Teks Konten */}
          <div className="relative z-20 flex flex-col justify-center items-start h-full px-4 sm:px-8 lg:px-24">
            <p className="text-white text-sm sm:text-base mb-2">Layanan</p>
            <div className="space-y-2 sm:space-y-3 max-w-full sm:max-w-xl">
              <h1 className="bg-white text-red-600 text-xl sm:text-3xl lg:text-4xl font-bold px-4 sm:px-6 py-2 rounded-md shadow max-w-fit font-pontano">
                Dana Pensiun Memberikan Layanan Optimal Untuk Masa Pensiun Anda
              </h1>
              {/* <h1 className="bg-white text-red-600 text-xl sm:text-3xl lg:text-4xl font-bold px-4 sm:px-6 py-2 rounded-md shadow max-w-fit font-pontano">
                Optimal Untuk Masa Pensiun Anda
            </h1> */}
            </div>
          </div>
        </section>

        <section className="relative z-20 bg-white rounded-t-[40px] -mt-12 sm:-mt-16 shadow-md px-4 sm:px-8 lg:px-24 py-8 sm:py-12">
          {/* Judul */}
          <h2 className="text-2xl sm:text-3xl font-bold mb-6 text-gray-800 font-pontano">
            Layanan
          </h2>

          {/* Tabs */}
          <div className="flex flex-wrap gap-3 mb-8">
            <button
              className={`px-4 sm:px-5 py-2 border ${
                activeTab === "edukasi"
                  ? "border-[#062382] text-white bg-[#062382]"
                  : "border-[#F1F1F1] text-[#919191] bg-[#F1F1F1] shadow-sm"
              } rounded-full text-xs sm:text-sm transition`}
              onClick={() => setActiveTab("edukasi")}
            >
              Edukasi Dana Pensiun
            </button>
            <button
              className={`px-4 sm:px-5 py-2 border ${
                activeTab === "prosedur"
                  ? "border-[#062382] text-white bg-[#062382]"
                  : "border-[#F1F1F1] text-[#919191] bg-[#F1F1F1] shadow-sm"
              } rounded-full text-xs sm:text-sm transition`}
              onClick={() => setActiveTab("prosedur")}
            >
              Prosedur Klaim Dana Pensiun
            </button>
          </div>

          {/* Konten Tab */}
          {activeTab === "edukasi" && (
            <div className="w-full text-gray-700 leading-relaxed text-sm sm:text-base">
              <h3 className="text-xl sm:text-2xl font-semibold mb-4 font-pontano">
                Dana Pensiun
              </h3>
              <p>
                Dana Pensiun Pemberi Kerja, artinya pesertanya hanyalah para
                karyawan dari Pendiri dan Mitra Pendiri Dana Pensiun Tersebut.
                Adapun Program adalah Program Manfaat Pasti. Setiap peserta yang
                berhenti bekerja akan mendapatkan manfaat pensiun sebesar Nilai
                Sekarang x 1,5 x Masa Kerja (Dalam Tahun) x Penghasilan Dasar
                Pensiun. Adapun yang ditetapkan sebagai Penghasilan Dasar
                Pensiun adalah Gaji Pokok Terakhir.
              </p>

              <div className="self-center mt-5">
                <a
                  href={
                    process.env.PUBLIC_URL +
                    "/pdfs/Edukasi untuk peserta DPTA.pptx"
                  }
                  download
                  className="inline-flex items-center gap-2 px-3 py-3 bg-[#EB0A1E] text-white text-sm rounded-lg hover:bg-red-700 transition self-start cursor-pointer"
                >
                  Download Materi Edukasi
                  <img
                    src="/images/asset/download.svg"
                    alt="Download"
                    className="w-4 h-4"
                  />
                </a>
              </div>
            </div>
          )}

          {activeTab === "prosedur" && (
            <div className="w-full text-gray-700 leading-relaxed text-sm sm:text-base">
              <h3 className="text-xl sm:text-2xl font-semibold mb-4 font-pontano">
                Prosedur Klaim Dana Pensiun
              </h3>
              <p>
                Prosedur pembelian anuitas adalah rangkaian proses yang harus
                dilalui oleh peserta pensiun normal atau ahli waris peserta yang
                meninggal untuk mendapatkan manfaat pensiun dalam bentuk anuitas
                dari Dana Pensiun (DP). Proses ini terdiri dari beberapa tahapan
                sebagai berikut:
              </p>
              <div className="self-center mt-5">
                <a
                  href="https://forms.gle/WJukAkTLu5T87sGw9"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 px-3 py-3 bg-[#EB0A1E] text-white text-sm rounded-lg hover:bg-red-700 transition self-start cursor-pointer"
                >
                  Klaim Dana Pensiun
                </a>
              </div>
            </div>
          )}
        </section>

        {/* Pindahkan bagian prosedur asli ke dalam tab (opsional), atau sembunyikan jika tidak aktif */}
        {activeTab === "edukasi" && (
          <section className="relative bg-[#082B89] text-white py-10 px-4 sm:px-8 lg:px-24 overflow-hidden">
            <h2 className="text-lg sm:text-xl font-semibold mb-6 font-pontano">
              Prosedur Klaim Dana Pensiun
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 relative z-10">
              {[
                {
                  title: "Step 1",
                  desc: "Pada saat karyawan berhenti bekerja (mencapai usia pensiun normal yaitu 55 tahun, meninggal dunia, mengundurkan diri sebagai karyawan), HRD Pendiri atau Mitra Pendiri akan mengeluarkan surat keterangan berhenti bekerja (Surat Verklaaring).",
                },
                {
                  title: "Step 2",
                  desc: "Atas dasar surat Verklaaring tersebut, Dana Pensiun akan membuat Nota Perhitungan Manfaat Pensiun, yang ditanda tangani oleh peserta.",
                },
                {
                  title: "Step 3",
                  desc: "Peserta menanda tangani, memberikan kelengkapan dokumen: Copy KTP, NPWP, Kartu Keluarga, dan Surat Keterangan lain yang diperlukan (dalam kasus karyawan meninggal dunia atau manfaat pension akan dialihkan).",
                },
                {
                  title: "Step 4",
                  desc: "Setelah semua persyaratan lengkap, Dana Pensiun akan membayarkan manfaat pension sesuai peraturan yang berlaku.",
                },
              ].map((item, idx) => (
                <div
                  key={idx}
                  className="border border-white/40 bg-white/5 backdrop-blur-sm rounded-md p-4 flex flex-col gap-2 min-h-[170px]"
                >
                  <div className="flex items-center gap-2">
                    <img
                      src="/images/asset/pen.svg"
                      alt="Pen"
                      className="w-6 h-6"
                    />
                    <span className="font-semibold text-white">
                      {item.title}
                    </span>
                  </div>
                  <p className="text-sm leading-relaxed text-white/90">
                    {item.desc}
                  </p>
                </div>
              ))}
            </div>

            <img
              src="/images/asset/coin-2.svg"
              alt="Rp Background"
              className="absolute top-0 right-0 w-36 sm:w-48 lg:w-56 opacity-80"
            />
            <img
              src="/images/asset/hand.svg"
              alt="Rp Background"
              className="absolute bottom-0 left-0 w-36 sm:w-48 lg:w-56 opacity-80"
            />
          </section>
        )}

        {activeTab === "prosedur" && (
          <section className="relative bg-[#082B89] text-white py-10 px-4 sm:px-8 lg:px-24 overflow-hidden">
            <div className="w-full flex justify-center px-4">
              <img
                src="/images/asset/prosedur-flow.jpeg"
                alt="People"
                className="w-full max-w-2xl h-auto object-contain z-10"
              />
            </div>

            <img
              src="/images/asset/coin-2.svg"
              alt="Rp Background"
              className="absolute top-0 right-0 w-36 sm:w-48 lg:w-56 opacity-80"
            />
            <img
              src="/images/asset/hand.svg"
              alt="Rp Background"
              className="absolute bottom-0 left-0 w-36 sm:w-48 lg:w-56 opacity-80"
            />
          </section>
        )}
      </div>
    </>
  );
};

export default Layanan;
